import { CreateTempUserInfoMapper } from "@/data/mapper/user/create-temp-user-info-mapper";
import { UserInfoMapper } from "@/data/mapper/user/user-info-mapper";
import { CreateTempUserRequestPayload } from "@/data/payload/user/create-temp-user-request-payload";
import { safeMapToEntity } from "@/data/repo-Implement/safe-map-to-entity";
import { UserSource } from "@/data/source/user-source";
import { CreateTempUserResponseEntity } from "@/domain/entity/user/create-temp-user-response-entity";
import { UserInfoEntity } from "@/domain/entity/user/user-info-entity";
import { UserRepository } from "@/domain/repository/user-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class UserRepositoryImpl implements UserRepository {
  constructor(private readonly userSource: UserSource) {}

  async fetchWebUserInfo(): Promise<SATResult<UserInfoEntity, SATError>> {
    const result = await this.userSource.fetchWebUserInfo();
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    return safeMapToEntity(
      result.value,
      UserInfoMapper.toEntity,
      "UserRepositoryImpl::fetchWebUserInfo",
    );
  }

  async createTempUser(
    payload: CreateTempUserRequestPayload,
  ): Promise<SATResult<CreateTempUserResponseEntity, SATError>> {
    const result = await this.userSource.createTempUser(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    return safeMapToEntity(
      result.value,
      CreateTempUserInfoMapper.toEntity,
      "UserRepositoryImpl::createTempUser",
    );
  }
}
